import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { StampBadge } from '../StampBadge';
import { Reveal } from '../Reveal';
import { ArrowMark, Note } from '../Marks';

/** The brand in one breath, with the door to the full story. */
export function StoryTeaser() {
  const reduced = useReducedMotion();
  return <section aria-labelledby="historien" className="bg-smor text-black" data-id="element-627" data-mp="3r3014daqwrae">
      <div className="mx-auto grid max-w-page items-center gap-12 px-5 py-16 md:px-8 md:py-20 lg:grid-cols-[minmax(0,1.2fr),minmax(0,1fr)] lg:gap-20" data-id="element-628" data-mp="3r4ulnqi3uhdy">
        <Reveal data-id="element-629" data-mp="4vjyusk3lpot">
          <p className="text-[11px] font-bold uppercase tracking-wide3 text-black/55" data-id="element-630" data-mp="4uqrpqh88y65">Vilka vi är</p>
          <h2 id="historien" className="display-xl mt-4 text-[2.4rem] uppercase leading-[0.95] sm:text-[3.4rem]" data-id="element-631" data-mp="8y6ja8efw8bz">
            Smaken är som baken. Delad.
            <br data-id="element-632" data-mp="1kck1oxqfbvkm" />
            <span className="text-black/45" data-id="element-633" data-mp="1kc0tw9uhmnkb">Vi tog de bästa bitarna.</span>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-black/70" data-id="element-634" data-mp="2a7i0lq7nyu2e">
            Tolv saker ska sitta innan någon får vår stämpel. Miljön, doften, bemötandet, råvaran — hela
            vägen till mästerverket.
          </p>
          <Link to="/om" className="group mt-8 inline-flex items-center gap-3 bg-black px-8 py-4 text-[12px] font-bold uppercase tracking-wide2 text-papper transition-colors duration-150 ease-out hover:bg-rod" data-id="element-635" data-mp="2089bbanqu3md">
            Så väljer vi
            <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-636" data-mp="1mhno59r9b7io" />
          </Link>
        </Reveal>

        <motion.div initial={reduced ? false : {
        opacity: 0,
        scale: 1.2,
        rotate: -18
      }} whileInView={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="justify-self-start lg:justify-self-end" data-id="element-637" data-mp="1hjceaz0yox0g">
          <span className="flex items-center justify-center bg-papper px-8 py-8 sm:px-12 sm:py-10" data-id="element-638" data-mp="tv663zvmtkfe">
            <StampBadge className="w-56 sm:w-72" data-id="element-639" data-mp="xxsqxgtvy533" />
          </span>
          <Note className="mt-4 block text-black/70" data-id="element-640" data-mp="xuy5pn31sg8m">Får bara de som klarar allt.</Note>
        </motion.div>
      </div>
    </section>;
}